"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.goldenbull = void 0;
exports.goldenbull = {
    masterchef: "0x2e47630f1a7807b596267361f9DD4C534632Ae98",
};
